import { render } from "./Testimonial1Page.vue?vue&type=template&id=9c3f99b4&scoped=true&ts=true"
import script from "./Testimonial1Page.vue?vue&type=script&lang=ts"
export * from "./Testimonial1Page.vue?vue&type=script&lang=ts"

import "./Testimonial1Page.vue?vue&type=style&index=0&id=9c3f99b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c3f99b4"]])

export default __exports__